import { useContext, useEffect } from 'react';
import { MiniCardGrafico } from './MiniCardGrafico';
import { useSolicitudCoberturaIniciadoAutorizadoTotales } from '../hooks';
import { SolicitudCoberturaContext } from '../context';
import dayjs from 'dayjs';
import { GraficoLine } from './GraficoLine';
import { Grid } from '@mui/material';

export const IniciadoAutorizadoAnualDemorasTotal = () => {
  const { anualList, anualDate } = useContext(SolicitudCoberturaContext);
  const { 
    dataDemora0_3Anual, 
    dataDemora4_7Anual, 
    dataDemora7MasAnual, 
    getTramitesAnualDemoras 
  } = useSolicitudCoberturaIniciadoAutorizadoTotales({
    anualList,
    anualDate,
  });

  useEffect(() => {
    if (anualList?.length > 0 && anualDate) {
      getTramitesAnualDemoras();
    }
  }, [anualList, anualDate]);

  return (
    <>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataDemora0_3Anual?.total || 0}
          title={
            <>
              <span>En proceso normal de autorización</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataDemora0_3Anual?.labels || []}
            datasets={dataDemora0_3Anual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataDemora4_7Anual?.total || 0}
          title={
            <>
              <span>Autorizaciones con demora de 4 a 7 días</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataDemora4_7Anual?.labels || []}
            datasets={dataDemora4_7Anual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
      <Grid item xs={12} sm={3}>
        <MiniCardGrafico
          total={dataDemora7MasAnual?.total || 0}
          title={
            <>
              <span>Autorizaciones con demora de +7 días</span>
            </>
          }
          subtitle={dayjs(anualDate).format('YYYY')}
        >
          <GraficoLine
            labels={dataDemora7MasAnual?.labels || []}
            datasets={dataDemora7MasAnual?.datasets || []}
          />
        </MiniCardGrafico>
      </Grid>
    </>
  );
};